import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';

const initialState = {};

@observer
class Tooltip extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...initialState,
        };
        this.container = null;
    }

    onMouseOver = e => {
        let width;
        let height;
        let rect;
        if (this.container) {
            // Width and height of the tooltip
            width = this.container.offsetWidth;
            height = this.container.offsetHeight;
            if (this.props.fixed && this.container.getBoundingClientRect) {
                // Viewport position of the trigger, so a position-fixed popup escapes overflow wrappers
                rect = this.container.getBoundingClientRect();
            }
        }
        this.setState({
            show: true,
            width,
            height,
            rect,
        });
    }

    onMouseOut = e => {
        this.setState({
            show: false,
        });
    }

    render() {
        const {
            styles = '',
            text,
            children,
            left = 0,
            width = 230,
            fixed = false,
        } = this.props;
        const {
            show,
            height,
            rect,
        } = this.state;
        // `fixed`: place the popup relative to the viewport so an overflow container (e.g. .table-responsive)
        // cannot clip it. Default keeps the original position-absolute behaviour for every other caller.
        const useFixed = fixed && rect;
        const positionClass = useFixed ? 'position-fixed' : 'position-absolute';
        const positionStyle = useFixed
            ? `top: ${Math.round(rect.bottom) + 5}px; left: ${Math.round(rect.left) + left}px;`
            : `top: ${height + 5}px; left: ${left}px;`;

        return (<>
            <span
                class={`${styles} position-relative`}
                onMouseOver={this.onMouseOver}
                onMouseOut={this.onMouseOut}
                ref={c => this.container = c}
            >
                {text}

                {show && <>
                    <div
                        class={`${positionClass} bg-light border font-weight-light p-4 text-start rounded-lg shadow`}
                        style={`${positionStyle} width: ${width}px; z-index: 1000000;`}
                    >
                        {children}
                    </div>
                </>}
            </span>
        </>);
    }
}

export default Tooltip;
